'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _TSForm = require('../ui/TSForm');

var _Input = require('../ui/Input');

var _Input2 = _interopRequireDefault(_Input);

var _Button = require('../ui/Button');

var _Button2 = _interopRequireDefault(_Button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import { getErrorMessage } from '../../utils/auth-error'

var ResetPassword = function (_Component) {
  (0, _inherits3.default)(ResetPassword, _Component);

  function ResetPassword() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, ResetPassword);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ResetPassword.__proto__ || Object.getPrototypeOf(ResetPassword)).call.apply(_ref, [this].concat(args))), _this), _this.handleSubmit = function (e) {
      e.preventDefault();
      _this.props.handleSubmit();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(ResetPassword, [{
    key: 'render',
    value: function render() {
      var error = this.props.user.error;

      return _react2.default.createElement(
        _react.Fragment,
        null,
        _react2.default.createElement(
          'h2',
          null,
          '\xC5terst\xE4ll l\xF6senord'
        ),
        _react2.default.createElement('br', null),
        this.form
      );
    }
  }, {
    key: 'form',
    get: function get() {
      var _props = this.props,
          loading = _props.loading,
          email = _props.email,
          setField = _props.setField;

      return _react2.default.createElement(
        'form',
        { noValidate: true,
          method: 'post',
          className: 'form form--modal',
          onSubmit: this.handleSubmit.bind(this) },
        _react2.default.createElement(
          'div',
          { className: 'form-item form-text' },
          _react2.default.createElement(
            'label',
            null,
            'E-postadress'
          ),
          _react2.default.createElement(_Input2.default, { type: 'text',
            placeholder: 'Epostadress',
            name: 'email',
            value: email,
            onChange: setField.bind(null, 'email')
          })
        ),
        _react2.default.createElement(
          'div',
          { className: 'form-item form-text' },
          _react2.default.createElement(_Button2.default, { type: _Button.TYPES.PRIMARY,
            size: _Button.SIZES.LARGE,
            text: '\xC5terst\xE4ll l\xF6senord' }),
          _react2.default.createElement(
            'p',
            null,
            'Har du inget konto \xE4n?',
            _react2.default.createElement(
              'a',
              { onClick: this.props.changeForm.bind(null, 'sign-up') },
              'Registrera dig'
            )
          )
        )
      );
    }
  }]);
  return ResetPassword;
}(_react.Component);

exports.default = ResetPassword;
module.exports = exports['default'];